import React from 'react';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import TabBar from './TabBar.js';
import Carousel from './Carousel.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'lodash';
import '@elliemae/ds-form/RequiredMark';
import 'memoize-one';
import 'resize-observer';
import 'styled-components';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-icons/ChevronLeft';
import '@elliemae/ds-button';
import './useResize.js';

var blockName = 'tabs-tab-bar';
var SubTabList = aggregatedClasses('div')(blockName, 'subtabs-list', function (_ref) {
  var withCarousel = _ref.withCarousel;
  return {
    carousel: withCarousel
  };
});

var SubTabBar = function SubTabBar(_ref2) {
  var withCarousel = _ref2.withCarousel,
      _ref2$tabs = _ref2.tabs,
      tabs = _ref2$tabs === void 0 ? [] : _ref2$tabs,
      _ref2$activeTab = _ref2.activeTab,
      activeTab = _ref2$activeTab === void 0 ? '' : _ref2$activeTab,
      _ref2$onTabClick = _ref2.onTabClick,
      onTabClick = _ref2$onTabClick === void 0 ? function () {
    return null;
  } : _ref2$onTabClick,
      firstSubtabRef = _ref2.firstSubtabRef,
      handleUpArrow = _ref2.handleUpArrow;
  return /*#__PURE__*/React.createElement(TabBar, {
    activeTab: activeTab,
    onTabClick: onTabClick,
    handleUpArrow: handleUpArrow,
    firstSubtabRef: firstSubtabRef,
    renderCustomTabBar: function renderCustomTabBar(_ref3) {
      var tabsComponents = _ref3.tabsComponents,
          innerRef = _ref3.innerRef;
      return /*#__PURE__*/React.createElement(SubTabList, {
        withCarousel: withCarousel,
        innerRef: innerRef,
        "data-testid": "subtabs-list"
      }, withCarousel ? /*#__PURE__*/React.createElement(Carousel, null, tabsComponents) : tabsComponents);
    },
    showSelectionIndicator: false,
    showSeparator: true,
    tabs: tabs
  });
};

SubTabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.element).isRequired,
  activeTab: PropTypes.string,
  onTabClick: PropTypes.func.isRequired,
  withCarousel: PropTypes.bool,
  handleUpArrow: PropTypes.func,
  firstSubtabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};

export default SubTabBar;
//# sourceMappingURL=SubTabBar.js.map
